import { useCallback, useMemo } from 'react';
import { initSvmGlobalState as initSvmGlobalStateAction, updateSvmAuthority as updateSvmAuthorityAction, updateSvmPresalePrice as updateSvmPresalePriceAction, updateSvmPriceFeed as updateSvmPriceFeedAction, withdrawSvmIncome as withdrawSvmIncomeAction, } from '../svm/svm-admin';
export function useSvmAdminActions({ toast, refreshSvmGlobalState }) {
    const deps = useMemo(() => ({
        toast,
        refreshSvmGlobalState,
    }), [toast, refreshSvmGlobalState]);
    const initSvmGlobalState = useCallback(async (params) => {
        await initSvmGlobalStateAction(params, deps);
    }, [deps]);
    const updateSvmAuthority = useCallback(async (authority) => {
        await updateSvmAuthorityAction(authority, deps);
    }, [deps]);
    const updateSvmPresalePrice = useCallback(async (presalePrice) => {
        await updateSvmPresalePriceAction(presalePrice, deps);
    }, [deps]);
    const updateSvmPriceFeed = useCallback(async (params) => {
        await updateSvmPriceFeedAction(params, deps);
    }, [deps]);
    const withdrawSvmIncome = useCallback(async () => {
        await withdrawSvmIncomeAction(deps);
    }, [deps]);
    return {
        initSvmGlobalState,
        updateSvmAuthority,
        updateSvmPresalePrice,
        updateSvmPriceFeed,
        withdrawSvmIncome,
    };
}
